import { useRef, useCallback, useEffect } from "react";
export function useDebounce(func, delay = 1000) {
    const timer = useRef(undefined);
    return useCallback((...args) => {
        window.clearTimeout(timer.current);
        timer.current = setTimeout(() => func(...args), delay);
    }, [func, delay]);
}
export const useDebouncedEffect = (fn, deps, time) => {
    const dependencies = [...deps, fn, time];
    useEffect(() => {
        const timeout = setTimeout(fn, time);
        return () => {
            clearTimeout(timeout);
        };
    }, dependencies);
};
//# sourceMappingURL=useDebounce.js.map